import type { OrionSettings } from '../context/default-settings';
import { useOrion } from '../context/OrionProvider';

/**
 * Hook to access Orion settings from the current context.
 *
 * Initially the settings returned are the `defaultSettings`, even if the Orion settings are already cached in the browser. In case
 * the Orion settings have been previously cached, you may expect the `defaultSettings` to be updated with the last fetched settigs quickly.
 * The value of `isLoadingResponse` can be used by the caller to understand if Orion is currently fetching the settings, and thus if the
 * returned settings are the default values.
 * If Orion doesn't answer within the fetch timeout (10 seconds currently), `isLoadingResponse` becomes false so that callers
 * can stop waiting for the response.
 */
export function useOrionSettings(): {
  settings: OrionSettings;
  isLoadingResponse: boolean;
} {
  const { identity, isLoadingResponse } = useOrion();
  return {
    settings: identity.settings,
    isLoadingResponse,
  };
}
